import { IIdObject } from '@common/interfaces/id-object.interface';
import dayjs from 'dayjs';
import { apiHooks } from '../hooks/api-hooks';
import { IBoxCustomisationConfig } from '../pack-house-generated-api';
import { createDefaultProduceDto, IBoxCustomisationConfigDefaultProduceDto } from './box-customisation-default-produce.dto';
import { IProductCatalogItemDto } from './product-catalog-item.dto';

// configuration for box customisation - similar to sales config
export interface IBoxCustomisationConfigDto extends Omit<IBoxCustomisationConfig, 'id' | 'default_produce'>, IIdObject {
    id: string;
    salesFrom: Date;
    salesTo: Date;
    productObj: IProductCatalogItemDto | undefined;
    defaultProduceSorted: IBoxCustomisationConfigDefaultProduceDto[];
}

export const createBoxCustomisationConfigDto = (data: IBoxCustomisationConfig): IBoxCustomisationConfigDto => {
    const allProducts = apiHooks.packHouse.getProductsFromCache();
    const product = allProducts?.list.find((f) => f.id === data?.box_id);

    return {
        ...data,
        id: data?.id || '',
        salesFrom: dayjs((data?.sales_availability_from || 1) * 1000).toDate(),
        salesTo: dayjs((data?.sales_availability_to || 1) * 1000).toDate(),
        defaultProduceSorted:
            data.default_produce
                ?.sort((a, b) => (a.order || 0) - (b.order || 0))
                .map((item) => createDefaultProduceDto(item)) || [],
        productObj: product,
    };
};
